import React from 'react';

const PrivacyPage = () => {
  const handleBackToHome = (e) => {
    e.preventDefault();
    // Navigate back to home page
    window.location.href = '/';
  };

  return (
    <div style={{ padding: '40px', maxWidth: '800px', margin: '0 auto', fontFamily: 'Arial, sans-serif', lineHeight: '1.6', fontSize: '14px' }}>
      <h1 style={{ color: '#1e3a5f', borderBottom: '3px solid #ffc107', paddingBottom: '10px', fontSize: '28px', fontWeight: 'bold' }}>PRIVACY POLICY</h1>
      
      <h2 style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px', color: '#2d3748' }}>1. Introduction</h2>
      <p style={{ fontSize: '14px', marginBottom: '15px' }}>planAIdesign Pty Ltd (ABN: 33 689 275 581) ("we", "us", "our") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our website and services for low-rise residential development planning in NSW.</p>
      
      <p style={{ fontSize: '14px', marginBottom: '15px' }}>We comply with the Australian Privacy Principles (APPs) contained in the Privacy Act 1988 (Cth) and any applicable state privacy legislation.</p>
      
      <h2 style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px', color: '#2d3748' }}>2. Information We Collect</h2>
      
      <h3 style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '20px', marginBottom: '10px', color: '#4a5568' }}>2.1 Personal Information</h3>
      <p style={{ fontSize: '14px', marginBottom: '10px' }}>We may collect the following personal information:</p>
      <ul style={{ fontSize: '14px', paddingLeft: '20px', marginBottom: '15px' }}>
        <li>Full name</li>
        <li>Email address</li>
        <li>Phone number</li>
        <li>Property addresses for development assessment</li>
        <li>Login credentials (username and encrypted password)</li>
        <li>Payment information (processed and stored securely through Stripe, including card details for authorized auto-charge purposes)</li>
        <li>Business name and ABN (if applicable)</li>
      </ul>
      
      <h3 style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '20px', marginBottom: '10px', color: '#4a5568' }}>2.2 Project Information</h3>
      <ul style={{ fontSize: '14px', paddingLeft: '20px', marginBottom: '15px' }}>
        <li>Property details and site information</li>
        <li>Development requirements and preferences</li>
        <li>Uploaded documents and plans</li>
        <li>Communication history regarding your projects</li>
      </ul>
      
      <h3 style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '20px', marginBottom: '10px', color: '#4a5568' }}>2.3 Technical Information</h3>
      <ul style={{ fontSize: '14px', paddingLeft: '20px', marginBottom: '15px' }}>
        <li>IP address</li>
        <li>Browser type and version</li>
        <li>Device information</li>
        <li>Usage data and analytics (via Firebase)</li>
        <li>Cookies and similar tracking technologies</li>
      </ul>
      
      <h2 style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px', color: '#2d3748' }}>3. How We Use Your Information</h2>
      <p style={{ fontSize: '14px', marginBottom: '10px' }}>We use your information to:</p>
      <ul style={{ fontSize: '14px', paddingLeft: '20px', marginBottom: '15px' }}>
        <li>Provide site investigation and feasibility assessment services</li>
        <li>Create concept designs and 3D models</li>
        <li>Process payments for our services, including authorized auto-charges for Stage 1 services as per our Terms of Service</li>
        <li>Manage your account and provide customer support</li>
        <li>Send service updates and project communications</li>
        <li>Improve our services and user experience</li>
        <li>Comply with legal obligations</li>
        <li>Send marketing communications (with your consent)</li>
      </ul>
      
      <h2 style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px', color: '#2d3748' }}>4. Third-Party Services</h2>
      <p style={{ fontSize: '14px', marginBottom: '10px' }}>We use the following third-party services:</p>
      <ul style={{ fontSize: '14px', paddingLeft: '20px', marginBottom: '15px' }}>
        <li>Firebase (Google): Authentication, database, and analytics</li>
        <li>Vercel: Website hosting and deployment</li>
        <li>EmailJS: Email communication services</li>
        <li>Stripe: Secure payment processing and card storage for authorized auto-charge purposes (your card details are stored by Stripe, not on our servers)</li>
      </ul>
      
      <p style={{ fontSize: '14px', marginBottom: '15px' }}>These services may collect and process data according to their own privacy policies. We encourage you to review their policies.</p>
      
      <h2 style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px', color: '#2d3748' }}>5. Data Security</h2>
      <p style={{ fontSize: '14px', marginBottom: '10px' }}>We implement appropriate technical and organizational measures to protect your personal information, including:</p>
      <ul style={{ fontSize: '14px', paddingLeft: '20px', marginBottom: '15px' }}>
        <li>SSL/TLS encryption for data transmission</li>
        <li>Secure password hashing</li>
        <li>Regular security updates and monitoring</li>
        <li>Restricted access to personal information</li>
        <li>Secure payment processing through PCI-compliant providers</li>
      </ul>
      
      <h2 style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px', color: '#2d3748' }}>6. Data Retention</h2>
      <p style={{ fontSize: '14px', marginBottom: '10px' }}>We retain your personal information for as long as necessary to:</p>
      <ul style={{ fontSize: '14px', paddingLeft: '20px', marginBottom: '15px' }}>
        <li>Provide our services</li>
        <li>Comply with legal obligations (minimum 7 years for financial records)</li>
        <li>Resolve disputes and enforce agreements</li>
        <li>Maintain records for professional liability purposes</li>
      </ul>
      
      <h2 style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px', color: '#2d3748' }}>7. Your Rights</h2>
      <p style={{ fontSize: '14px', marginBottom: '10px' }}>Under Australian privacy law, you have the right to:</p>
      <ul style={{ fontSize: '14px', paddingLeft: '20px', marginBottom: '15px' }}>
        <li>Access your personal information</li>
        <li>Correct inaccurate information</li>
        <li>Request deletion of your information (subject to legal requirements)</li>
        <li>Opt-out of marketing communications</li>
        <li>Lodge a complaint with the Office of the Australian Information Commissioner (OAIC)</li>
      </ul>
      
      <h2 style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px', color: '#2d3748' }}>8. Cookies</h2>
      <p style={{ fontSize: '14px', marginBottom: '10px' }}>We use cookies and similar technologies to:</p>
      <ul style={{ fontSize: '14px', paddingLeft: '20px', marginBottom: '15px' }}>
        <li>Maintain your session and preferences</li>
        <li>Analyze site traffic and usage</li>
        <li>Improve user experience</li>
      </ul>
      
      <p style={{ fontSize: '14px', marginBottom: '15px' }}>You can control cookies through your browser settings, but disabling them may affect site functionality.</p>
      
      <h2 style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px', color: '#2d3748' }}>9. International Data Transfers</h2>
      <p style={{ fontSize: '14px', marginBottom: '15px' }}>Some of our third-party providers may process data outside Australia. We ensure appropriate safeguards are in place to protect your information in accordance with Australian privacy laws.</p>
      
      <h2 style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px', color: '#2d3748' }}>10. Changes to This Policy</h2>
      <p style={{ fontSize: '14px', marginBottom: '15px' }}>We may update this Privacy Policy from time to time. We will notify you of significant changes via email or through our website.</p>
      
      <h2 style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px', color: '#2d3748' }}>11. Contact Us</h2>
      <p style={{ fontSize: '14px', marginBottom: '15px' }}>
        <strong>planAIdesign Pty Ltd</strong><br />
        ABN: 33 689 275 581<br />
        Email: team@planaidesign.com<br />
        Website: www.planaidesign.com.au
      </p>
      
      <h2 style={{ fontSize: '18px', fontWeight: 'bold', marginTop: '30px', marginBottom: '15px', color: '#2d3748' }}>12. Complaints</h2>
      <p style={{ fontSize: '14px', marginBottom: '15px' }}>If you have concerns about our privacy practices, please contact us first. If you're not satisfied with our response, you may lodge a complaint with the OAIC at www.oaic.gov.au</p>
      
      <br />
      <a 
        href="/" 
        onClick={handleBackToHome}
        style={{ color: '#2c5282', textDecoration: 'underline', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold' }}
      >
        ← Back to Home
      </a>
    </div>
  );
};

export default PrivacyPage;